// #644 — "68.5" from score-api's composite (score-common's
// calculateRideComposite rounds to 3 decimals; one is plenty to read aloud).
export function formatComposite(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n.toFixed(1) : "";
}

export default formatComposite;
